import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { buildWhatsAppUrl } from "../lib/contact";

export const FloatingCall = () => {
  const { t } = useLang();
  return (
    <div className="md:hidden fixed bottom-5 right-5 z-50 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={buildWhatsAppUrl(t.whatsappMessage)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="WhatsApp"
        className="h-14 w-14 rounded-full bg-[#25D366] inline-flex items-center justify-center shadow-[0_8px_24px_rgba(37,211,102,0.45)]"
      >
        <MessageCircle size={22} className="text-white" />
      </a>
      <a
        href="tel:+12407618778"
        data-testid="floating-call-btn"
        aria-label="Call now"
        className="h-14 w-14 rounded-full btn-heat inline-flex items-center justify-center animate-pulse-glow"
      >
        <Phone size={22} />
      </a>
    </div>
  );
};
